import React from 'react'
import './styles/App.css'
import { School } from '@mui/icons-material';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import "react-vertical-timeline-component/style.min.css";
import SkillSection from './components/SkillSection';
import {otherSkills, programmingSkills} from './helpers/Skills';
import ProjectSection from './components/ProjectSection';
import Projects from './helpers/Projects';

function App() {
  return (
    <div>
        <div className="front-page">
            <h1><strong>Dean Perillo</strong></h1>
            <h3>Backend Developer @ IBM</h3>
            <div id="arrowAnim">
                <div className="arrowSliding">
                    <div className="arrow"></div>
                </div>
                <div className="arrowSliding delay1">
                    <div className="arrow"></div>
                </div>
                <div className="arrowSliding delay2">
                    <div className="arrow"></div>
                </div>
                <div className="arrowSliding delay3">
                    <div className="arrow"></div>
                </div>
            </div>
        </div>
        <br></br>
        <section className="about-me-section">
      <div className="about-me-content">
        <div className="about-me-text">
          <h2>About Me</h2>
          <p>
            I’m Dean Perillo, a Backend Developer at IBM working on the <a href="https://research.ibm.com/blog/spyre-for-z" target="_blank">Spyre AI accelerator</a>. 
          </p>
          <p>
            I recently earned my Master’s in Computer Science from SUNY New Paltz, and I’m excited to start applying AI techniques to real-world problems. This website highlights my skills and projects, both from my studies and personal work, as I continue learning in the AI and software development fields.
          </p>
        </div>
      </div>
    </section>
    <div>
    <h1>Skills</h1>
    <h1>Programming Languages</h1>
    <SkillSection logos={programmingSkills} sliderColor ="#121329"></SkillSection>
    <br/>
    <h1>Other Skills</h1>
    <SkillSection logos={otherSkills} sliderColor ="#121329"></SkillSection>
    <br/><br/>
    <h1>Projects</h1>
    <ProjectSection projectData={Projects[0]}></ProjectSection>
    <br/><br/>
    <ProjectSection projectData={Projects[1]}></ProjectSection>
    <br/><br/>
    <ProjectSection projectData={Projects[2]}></ProjectSection>
    <h1>Education</h1>
    <br/><br/>
      <VerticalTimeline lineColor="#3e497a">
      <VerticalTimelineElement 
          className="vertical-timeline-element--education"
          date="2023-2024"
          contentStyle={{ background: '#121329', color: '#fff' }}
          iconStyle={{background: "#de497a", color: "#fff"}}
          icon={<School />}
        >
          <h3 className="vertical-timeline-element-title">SUNY New Paltz, New Paltz, NY</h3>
          <p> M.S. in Computer Science </p>
          <p><strong>Current GPA: 3.96/4.0</strong></p>
          <p><em><strong>Course work includes:</strong></em> Thesis in Computer Science, Programming and Data Structures, Discrete Structures,
                  User Interface Programming, Network Security, Web and Database Programming, Artificial Intelligence, Cybersecurity, and Deep Learning.</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement 
          className="vertical-timeline-element--education"
          date="2020-2023"
          contentStyle={{ background: '#121329', color: '#fff' }}
          iconStyle={{background: "#9e497a", color: "#fff"}}
          icon={<School />}
        >
          <h3 className="vertical-timeline-element-title">SUNY Polytechnic Institute, Utica, NY</h3>
          <p> B.S. in Computer and Information Science </p>
          <p><strong>GPA: 3.75/4.0 Overall, 3.88/4.0 In-major.</strong></p>
          <p><em><strong>Course work includes:</strong></em>  Computer Fundamentals, Data Structures, Computer Organization,
                  Object Oriented Programming, Operating Systems and Networking, Software Engineering,
                  Git, Docker, Kubernetes, Calculus, Discrete Math, Linear Algebra, Statistical Methods,
                  Information and Knowledge Management, Principles of Programming Languages, Computer
                  Vision & Image Processing, Artificial Intelligence, and Computer Graphics.</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement 
          className="vertical-timeline-element--education"
          date="2016-2020"
          contentStyle={{ background: '#121329', color: '#fff' }}
          iconStyle={{background: "#3e497a", color: "#fff"}}
          icon={<School />}
        >
          <h3 className="vertical-timeline-element-title">Wallkill Senior High School, Wallkill, NY</h3>
          <p> High School Advanced Regents Diploma </p>
          <p> Participated in Project Lead the Way</p>
          <p><em><strong>PLTW Courses:</strong></em> Introduction To Engineering Design, Digital Logic,
                 Principles of Engineering, Engineering Design and Development, Automation and Robotics</p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
    </div>
  )
}

export default App